import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend';
import { asArray, sortArray } from '@nu-art/ts-common';
import { ModuleFE_PathwayTransition } from '../../../../../../../_entity/pathway-transition/index.js';
import { Renderer_Transitions } from '../../../../../renderers/Renderer_Transitions.js';
export class Section_StateTransitions extends ComponentSync {
    __onPathwayTransitionUpdated(...params) {
        const pathwayStateId = this.props.pathwayStateId;
        if (!pathwayStateId)
            return;
        switch (params[0]) {
            case 'delete':
            case 'delete-multi': {
                const deletedTransition = asArray(params[1]);
                if (deletedTransition?.some(deletedTransition => this.state.relevantTransitions.find(transition => transition._id === deletedTransition._id)))
                    return this.reDeriveState();
                break;
            }
            case 'update':
            case 'upsert-all':
            case 'create': {
                const updatedTransitions = asArray(params[1]);
                if (updatedTransitions?.some(transition => transition.sourceId === pathwayStateId ||
                    this.state.relevantTransitions.some(rt => rt._id === transition._id))) {
                    return this.reDeriveState();
                }
                break;
            }
        }
    }
    deriveStateFromProps(nextProps, state) {
        const pathwayStateId = nextProps.pathwayStateId;
        const prevPathwayStateId = this.props?.pathwayStateId;
        // Always refresh transitions from cache to ensure we have the latest data
        const newTransitions = sortArray(ModuleFE_PathwayTransition.cache.filter(pt => pt.sourceId === pathwayStateId), item => item.priorityIndex) ?? [];
        // Initialize state.relevantTransitions if it doesn't exist
        state.relevantTransitions ??= [];
        // Update if stateId changed, or if transitions have actually changed
        const stateIdChanged = pathwayStateId !== prevPathwayStateId;
        const transitionsChanged = stateIdChanged ||
            newTransitions.length !== state.relevantTransitions.length ||
            newTransitions.some((t, i) => t._id !== state.relevantTransitions[i]?._id || t.__updated !== state.relevantTransitions[i]?.__updated);
        if (transitionsChanged) {
            state.relevantTransitions = newTransitions;
        }
        return state;
    }
    render() {
        return _jsx(Renderer_Transitions, { transitions: this.state.relevantTransitions, functions: this.props.functions, isFromState: true });
    }
}
//# sourceMappingURL=Section_StateTransitions.js.map